<template>
  <div v-if="!isPageError">
    <b-row v-if="isLoading" class="justify-content-md-center">
      <b-col lg="6">
        <div class="d-flex justify-content-center">
          <b-spinner label="Loading..." variant="dark" />
        </div>
      </b-col>
    </b-row>

    <div v-else class="mb-5">
      <!-- <b-row class="justify-content-end">
        <b-col cols="4" class="form-group">
          <label for="showFilter" class="mr-2"> Show :</label>
          <select
            id="showFilter"
            class="form-control"
            style="display: inline; width: 50%"
          >
            <option selected>All</option>
          </select>
        </b-col>
      </b-row> -->

      <!-- Learning Outcome -->

      <!-- <base-learning-outcome-and-criterion
        v-if="learningOutcome"
        title="Learning outcome"
        :description="learningOutcome.description"
        :pass-criterion="learningOutcome.pass_criterion"
        :not-yet-criterion="learningOutcome.not_yet_criterion"
        class="mb-5 container__lo"
      /> -->

      <!-- <ultimate-learning-outcome
        v-if="learningUnit"
        class="mb-5 container__ultimate-lo"
        :learningUnit="learningUnit"
        :disabled="disabled || !canEditUltimateLO"
      /> -->

      <b-tabs v-model="activeTab" pills nav-class="nav-line nav-line-alt" content-class="pt-4">
        <tab-post-feed
          :user="user"
          :learners="learners"
          :learning-unit="learningUnit"
          :section="section"
          :disabled="disabled"
          :is-owner="isOwner"
          :editable="editable"
          :active="isTab('posts')"
        />

        <!-- <tab-direct-message
          :user="user"
          :learner="learner"
          :learning-unit="learningUnit"
          :section="section"
          :disabled="disabled"
          :is-learner="isLearner"
          :is-owner="isOwner"
          :active="isTab('direct-messages')"
        /> -->

        <!-- <tab-grant-obem
			v-if="isOwner && isOBEM"
			:learningUnitId="learningUnit.id"
			:sectionId="section.id"
			:active="isTab('grant-obem')"
			/> -->
        <TabCommunity
          :section-id="section.id"
          :learning-unit="learningUnit"
          :active="isTab('community')"
        />

        <TabLearners
          v-if="$currentUser.isLearningUnitMemberOf(learningUnit.id)"
          :learners="learners"
          :active="isTab('learner')"
        />
      </b-tabs>
    </div>
  </div>

  <b-container v-else fluid>
    <b-row class="justify-content-md-center">
      <b-col lg="6">
        <div>Something Went Wrong</div>

        <div>
          <b-button variant="outline-primary" class="mb-4" @click="gotoPreviousPage()">
            {{ isOwner ? 'Back to previous page' : 'View detail' }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Learner from '@/models/Learner';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import Post from '@/models/Post';
import AssessmentStatus from '@/models/AssessmentStatus';
import User from '@/models/User';
import UserEnrollment from '@/models/UserEnrollment';
// import TabDirectMessage from "./TabDirectMessage";
import TabPostFeed from './TabPostFeed';
// import TabGrantObem from "./TabGrantObem";
import TabLearners from './TabLearners.vue';
// import UltimateLearningOutcome from "@/components/LearningOutcome/UltimateLearningOutcome";
import TabCommunity from './TabCommunity.vue';
// TODO: maybe should use computed cuz some tab have condition
const nameTabs = ['posts', 'community', 'learner'];

export default {
  components: {
    // TabDirectMessage,
    TabPostFeed,
    // UltimateLearningOutcome,
    // TabGrantObem,
    TabCommunity,
    TabLearners
  },

  props: {
    user: {
      type: User,
      required: true
    },

    learningUnit: {
      type: LearningUnit,
      required: true
    },

    section: {
      type: Section,
      required: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      isPageError: false,
      postOrder: 'order:ASC',
      learnerIds: []
    };
  },
  computed: {
    isOBEM() {
      return this.learningUnit.isOBEM();
    },

    userEnrollments() {
      const { user_enrollments_ids = [] } = this.section;

      return UserEnrollment.findIn(user_enrollments_ids);
    },

    learners() {
      return Learner.findIn(this.learnerIds);
    },

    isLearner() {
      const learner = this.learners.find((learner) => learner.id === this.user.id);
      return learner !== undefined;
    },

    isOwner() {
      return this.learningUnit.canAccess(this.user.id) || this.user.isRole('reviewer');
    },

    editable() {
      return this.learningUnit.canEdit(this.user.id) || this.user.isRole('reviewer');
    },

    learner() {
      return this.learners && this.learners.length
        ? this.learners.find((learner) => learner.id === this.user.id)
        : null;
    },

    activeTab: {
      set(index) {
        let query = { ...this.$route.query };

        this.$set(query, 'tab', nameTabs[index]);

        this.$router.replace({ query });
      },
      get() {
        const indexTab = nameTabs.indexOf(this.$route.query.tab);

        return Number(indexTab);
      }
    },

    canEditUltimateLO() {
      return this.user && this.learningUnit
        ? this.user.isRole('reviewer') ||
            (this.learningUnit.isOwnerOrInstructor(this.user.id) && !this.learningUnit.is_published)
        : false;
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'init'
    }
  },
  mounted() {
    // this.isLearner();
  },

  methods: {
    isTab(tabName) {
      const { tab = '' } = this.$route.query;

      return tab.length && tab === tabName;
    },

    async init() {
      this.isLoading = true;

      await this.fetch();

      this.isLoading = false;
    },

    async fetch() {
      try {
        Post.deleteAll();

        AssessmentStatus.deleteAll();

        const { response } = await Learner.api().findLearnersByLearningUnitId(
          this.learningUnit.id,
          ['LEARN_VERIFY']
        );

        const { data = [] } = response;

        this.learnerIds = data.map(({ id }) => id);
      } catch (error) {
        console.error(error);

        this.isPageError = true;
      }
    },

    gotoPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>
